import { CustomUseQueryOptions } from '../types';
import { API_TRANSLATION_DISABLED } from '@/client/confs/app';
import { hasNonEmptyProp } from '@/libs/common/utils';
import { ApiInstance, TranslateApiResult, TranslateBody } from '@/libs/sdk/api';
import { useQuery } from '@tanstack/react-query';

export const useApiTranslation = (
  api: ApiInstance,
  params: TranslateBody,
  options?: CustomUseQueryOptions<TranslateApiResult>
) => {
  const { enabled = true, queryKey, ...reset } = options || {};
  return useQuery({
    ...reset,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    gcTime: Infinity,
    staleTime: Infinity,
    enabled: enabled && !API_TRANSLATION_DISABLED && hasNonEmptyProp(params, true),
    queryKey: [queryKey, 'ApiTranslation', params],
    queryFn: async ({ signal }) => {
      const { data } = await api.base.translate(params, { signal });
      return data;
    },
  });
};
